import Constants from '@/constants.js'

export default {
  priceFilterLabel(filter) {
    let priceTo = filter.priceTo

    if (priceTo > 2000) {
      priceTo = '2000+'
    }

    return `€ ${filter.priceFrom} - ${priceTo}`
  },
  filterIdToGTM(values) {
    var results = []

    global.vesteda.settings.filters.map((filter) => {
      filter.values.map((v) => {
        if (v.id === values.add) {
          results.push({ name: filter.label, value: v.label, setting: 'on' })
        } else if (v.id === values.remove) {
          results.push({ name: filter.label, value: v.label, setting: 'off' })
        }
      })
    })

    return results
  },
  sizeFilterLabel(filter) {
    let sizelabel = '0 m<sup>2</sup> - 150+ m<sup>2</sup>'

    if (filter.sizes.length > 0) {
      sizelabel = ''

      filter.sizes.sort().forEach((element) => {
        if (sizelabel !== '') {
          sizelabel += ', '
        }

        switch (parseInt(element)) {
          case Constants.SizeTypes.ZeroToSeventy:
            sizelabel += '0 m<sup>2</sup> -70 m<sup>2</sup>'
            break
          case Constants.SizeTypes.SeventyToNinety:
            sizelabel += '70 m<sup>2</sup> - 90 m<sup>2</sup>'
            break
          case Constants.SizeTypes.NinetyToHundredTen:
            sizelabel += '90 m<sup>2</sup> - 110 m<sup>2</sup>'
            break
          case Constants.SizeTypes.HundredTenToHundredFifty:
            sizelabel += '110 m<sup>2</sup> - 150 m<sup>2</sup>'
            break
          case Constants.SizeTypes.MoreThanHundredFifty:
            sizelabel += '150+ m<sup>2</sup>'
            break
        }
      })
    }

    return sizelabel
  },
  allFiltersLabel(filter) {
    return `${global.vesteda.labels.price} : ${this.priceFilterLabel(
      filter
    )}, ${global.vesteda.labels.size} : ${this.sizeFilterLabel(filter)}`
  },
}
